import { isNumberUnit } from '@exodus/currency';
import { cleanInput } from '@exodus/basic-utils';
import { useGlobalState } from '@exodus/headless-react';
import { useCallback, useMemo } from 'react';
import useToAsset from './use-to-asset.js';
const defaultValue = '0';
const useToAmount = () => {
    const [toAsset] = useToAsset();
    const [toAmountValue, setToAmountValue] = useGlobalState({
        namespace: 'exchange',
        key: 'toAmount',
        defaultValue,
    });
    const resetToAmountValue = () => setToAmountValue(defaultValue);
    const currency = toAsset.currency;
    const handleToAmount = useCallback((value) => {
        if (isNumberUnit(value))
            value = value.toDefaultString();
        const decimals = currency.defaultUnit.power;
        const cleanedValue = cleanInput(String(value), decimals);
        setToAmountValue(cleanedValue);
    }, [currency, setToAmountValue]);
    const toAmount = useMemo(() => currency.defaultUnit(toAmountValue), [currency, toAmountValue]);
    return [toAmount, handleToAmount, resetToAmountValue];
};
export default useToAmount;
